import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';

import { BaseUI } from '../../base.ui';
import { Client } from '../../../domain/data';
import { ClientType, DocumentType, GetClientByDocumentUseCase, GetLegalDisclaimerUseCase } from '../../../../core';
import { ErrorDialog } from '../../dialog/error/error.dialog';
import { LegalDialog } from '../../dialog/legal/legal.dialog';
import { ParentEvents } from '../../../utils/parent-events.service';

import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'thr-contract-form-participant-natural-person',
    templateUrl: './contract-form-participant-natural-person.component.html',
    styleUrls: ['./contract-form-participant-natural-person.component.scss'],
})
export class ContractFormParticipantNaturalPersonComponent extends BaseUI implements AfterViewInit, OnDestroy {
    public DocumentType: typeof DocumentType = DocumentType;

    public cannotBeLegal = false;
    public today = moment();
    public hundredYears = moment().subtract(100, 'years');
    public isClientPortal = environment.portalClient;

    @Input()
    client: Client;

    @Input()
    pupil: Client;

    @Input()
    isFirst = false;

    constructor(
        parentEvents: ParentEvents,
        private dialog: MatDialog,
        private getClientByDocumentUseCase: GetClientByDocumentUseCase,
        private getLegalDisclaimerUseCase: GetLegalDisclaimerUseCase
    ) {
        super(parentEvents);
    }

    onDocumentBlur() {
        if (!this.isClientPortal && !this.isFirst && !!this.client.docId) {
            this.cannotBeLegal = false;

            this.getClientByDocumentUseCase
                .bind({
                    docType: this.client.docType,
                    docId: this.client.docId,
                })
                .subscribe((transaction) => {
                    if (transaction.isSuccess) {
                        if (
                            this.pupil &&
                            this.pupil.type === ClientType.LEGAL_PERSON &&
                            transaction.data.type !== ClientType.NATURAL_PERSON
                        ) {
                            this.client.docId = undefined;
                            this.cannotBeLegal = true;
                        } else {
                            const legalGuardianType = this.client.legalGuardianType;
                            this.client.copy(transaction.data);
                            this.client.acceptLegal = true;
                            this.client.disabled = true;
                            this.client.legalGuardianType = legalGuardianType;
                        }

                        this.parentEvents.resize();
                    }
                });
        }
    }

    onExonerate() {
        this.parentEvents.resize();
    }

    openDialog() {
        this.getLegalDisclaimerUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.dialog.open(LegalDialog, {
                    data: {
                        text: transaction.data,
                        title: 'dialog.info-rgpd-title',
                        ok: 'general.close',
                    },
                });
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }
}
